<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="fill-current inline-block"
    :class="[width, height]"
    viewBox="0 0 69.107 69.107"
  >
    <path
      id="Icon_material-cancel"
      data-name="Icon material-cancel"
      d="M37.554,3A34.554,34.554,0,1,0,72.107,37.554,34.522,34.522,0,0,0,37.554,3ZM54.831,49.958l-4.872,4.872-12.4-12.4-12.4,12.4-4.872-4.872,12.4-12.4-12.4-12.4,4.872-4.872,12.4,12.4,12.4-12.4,4.872,4.872-12.4,12.4Z"
      transform="translate(-3 -3)"
      fill="#f0324c"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: 'w-16'
    },
    height: {
      type: String,
      default: 'h-16'
    }
  }
}
</script>
